export const buyers = [
  { name: "Carlos Mendoza", place: "Mexico City, Mexico", ago: "2 min ago" },
  { name: "Andrés Gutiérrez", place: "Medellín, Colombia", ago: "4 min ago" },
  { name: "Javier Romero", place: "Madrid, Spain", ago: "1 min ago" },
  { name: "Luis Fernández", place: "Lima, Peru", ago: "6 min ago" },
  { name: "Diego Castillo", place: "Santiago, Chile", ago: "3 min ago" },
  { name: "José Ramírez", place: "Buenos Aires, Argentina", ago: "5 min ago" },
  { name: "Miguel Torres", place: "Guayaquil, Ecuador", ago: "2 min ago" },
  { name: "Ricardo Vargas", place: "Caracas, Venezuela", ago: "7 min ago" },
  { name: "Fernando Rojas", place: "Montevideo, Uruguay", ago: "1 min ago" },
  { name: "Alejandro Morales", place: "Santo Domingo, Dominican Republic", ago: "4 min ago" },
  { name: "Raúl Herrera", place: "San José, Costa Rica", ago: "3 min ago" },
  { name: "Pablo Navarro", place: "Asunción, Paraguay", ago: "8 min ago" },
  { name: "Héctor Jiménez", place: "Guatemala City, Guatemala", ago: "2 min ago" },
  { name: "Sergio Ortiz", place: "La Paz, Bolivia", ago: "5 min ago" },
  { name: "Manuel Cruz", place: "San Juan, Puerto Rico", ago: "1 min ago" },
  { name: "Óscar Delgado", place: "Panama City, Panama", ago: "6 min ago" },
];
